<div class="progress">
  <div class="progress__bar"
    [ngClass]="{'progress__bar--complete': percentWidth === 100}"
    [ngStyle]="{'width': percentWidth + '%'}"></div>
</div>